module.exports = __webpack_public_path__ + "static/media/matilde-special-indiana-bored.9b422350.png";